(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('testActivityEditor', testActivityEditor);

    function testActivityEditor() {
        return {
            templateUrl: '/app/directives/activities/test-activity-editor.tpl.html',
            scope: {
                item: '=',
                hideExaminers: '=',
                placeholder: '@',
                editMode: '=',
            },
            controller: TestActivityEditorController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function TestActivityEditorController() {
        var vm = this;
    }

})();